import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import { Image as ImageType } from './media/media.interface';

export const DEFAULT_MAX_WIDTH = 2160;

export const removeOrientationAndResizeImage =
  async function removeOrientationAndResizeImage(
    imageFile: File,
    targetMaxWidth?: number,
  ) {
    const img = new Image();
    img.src = URL.createObjectURL(imageFile);

    async function transformImageFile() {
      await new Promise((resolve) => {
        img.onload = resolve;
      });

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

      const aspectRatio = img.width / img.height;

      const exceedDefaultMaxWidth = img.width > DEFAULT_MAX_WIDTH;

      const exceedTargetMaxWidth = targetMaxWidth ? img.width > targetMaxWidth : false;

      const canvasWidth = targetMaxWidth
        ? exceedTargetMaxWidth
          ? targetMaxWidth
          : img.width
        : exceedDefaultMaxWidth
        ? DEFAULT_MAX_WIDTH
        : img.width;

      const canvasHeight = targetMaxWidth
        ? exceedTargetMaxWidth
          ? targetMaxWidth / aspectRatio
          : img.height
        : exceedDefaultMaxWidth
        ? DEFAULT_MAX_WIDTH / aspectRatio
        : img.height;

      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      const scale = Math.min(canvasWidth / img.width, canvasHeight / img.height);

      const scaledWidth = img.width * scale;
      const scaledHeight = img.height * scale;

      const x = (canvasWidth - scaledWidth) / 2;
      const y = (canvasHeight - scaledHeight) / 2;

      ctx.drawImage(img, x, y, scaledWidth, scaledHeight);

      const dataUrl = canvas.toDataURL(imageFile.type);
      const blob = await fetch(dataUrl).then((r) => r.blob());
      const retatedImageFile = new File([blob], imageFile.name, { type: imageFile.type });

      return retatedImageFile;
    }

    return transformImageFile();
  };

export const postImage = async (
  imageFile: File,
  assetRole: LowerRole,
  maxWidth?: number,
) => {
  try {
    const form = new FormData();
    const staticFile = await removeOrientationAndResizeImage(imageFile, maxWidth);
    form.append('image', staticFile);
    form.append('body', JSON.stringify({ name: imageFile.name }));

    const { data: image } = await api_.post<ImageType>(`${assetRole}/image/file`, form);
    return image;
  } catch (error) {
    console.log(`upload fail: ${JSON.stringify((error as any).message)}`);
    throw new Error('upload fail');
  }
};

export const postImages = async (imageFileList: FileList, assetRole: LowerRole) => {
  const imageIdList: string[] = [];
  try {
    for (const [key, value] of Object.entries(imageFileList)) {
      const image = await postImage(value, assetRole);
      imageIdList.push(image._id);
    }
  } catch (error) {
    console.log(`upload fail: ${JSON.stringify((error as any).message)}`);
    throw new Error('upload fail');
  }

  return imageIdList;
};
